// @flow weak

import { compose, branch, mapProps, renderNothing } from 'recompose';
import { graphql } from 'react-apollo';
import * as R from 'ramda';

import { VIEWER } from '~/gql';

export const withViewer = graphql(VIEWER, {
  alias: 'withViewer',
  options: {
    fetchPolicy: 'cache-and-network',
  },
  props: ({ data }) => data,
});

export const withUserRole = compose(
  withViewer,
  mapProps(
    ({ loggedInUser, viewer, ...rest }: LoggedInUserQuery & ViewerQuery) => {
      const roleSpecFn = R.pipe(
        R.prop('role'),
        R.applySpec({
          role: R.identity,
          isConsumer: R.equals('C'),
          isMerchant: R.equals('M'),
        }),
      );
      const isDepositUser = R.propOr(true, 'isDepositUser', loggedInUser || {});

      return {
        isDepositUser,
        ...roleSpecFn(viewer || {}),
        ...rest,
      };
    },
  ),
);

export const Viewer = compose(
  withViewer,
  branch(({ children }) => !children, renderNothing),
)(({ children, ...rest }) => children(rest));
